import { render, staticRenderFns } from "./BlogBreadcrumbs.vue?vue&type=template&id=7fba034f&"
import script from "./BlogBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./BlogBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports